<template>
    <div>
        <button class="ds-btn" @click="showModal">
            Pievienot
        </button>

        <b-modal :visible="isModalVisible" @hidden="hideModal" no-close-on-backdrop hide-footer body-class="p-2" header-class="bg-light align-items-center" size="lg">
            <div slot="modal-title">
                <h3 class="h4 text-dark font-weight-light m-0">
                    {{ selectedJobTitle._id ? 'Rediģēt amatu' : 'Pievienot amatu' }}
                </h3>
            </div>
            <div slot="modal-header-close">
            </div>
            <JobTitlesBaseForm @finished="handleJobTitleCreation"/>
        </b-modal>
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import JobTitlesBaseForm from './JobTitlesBaseForm';
    import * as jobTitleStoreTypes from '../../vuex/modules/company/modules/job-titles/job-title.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';

    export default {
        name: 'jobTitle-add',
        components: {JobTitlesBaseForm},
        computed: {
            ...mapGetters('jobTitle', {
                /** @type {User|*} */
                selectedJobTitle: jobTitleStoreTypes.GET_SELECTED_JOB_TITLE,
                /** @type {boolean|*} */
                isModalVisible: jobTitleStoreTypes.GET_IS_MODAL_VISIBLE,
            }),
        },
        methods: {
            ...mapMutations('company', {
                /** @type {function|*} */
                setCurrentCompanyJobTitles: companyStoreTypes.SET_CURRENT_COMPANY_JOB_TITLES,
            }),
            ...mapActions('jobTitle', {
                /** @type {function|*} */
                getJobTitles: jobTitleStoreTypes.ACTION_GET_JOB_TITLES,
                /** @type {function|*} */
                showModal: jobTitleStoreTypes.ACTION_SHOW_MODAL,
                /** @type {function|*} */
                hideModal: jobTitleStoreTypes.ACTION_HIDE_MODAL,
            }),
            async handleJobTitleCreation() {
                this.hideModal();
                const jobTitles = await this.getJobTitles({companyId: this.$route.params.companyId});
                this.setCurrentCompanyJobTitles(jobTitles);
            },
        },
    }
</script>